export default function FacebookDomainVerification() {
  return null;
}
